import React from 'react';
export function Footer() {
  return <footer className="bg-gray-50 border-t border-gray-200 py-6 md:py-12 px-4" data-id="element-62">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-63">
        <div className="font-display font-black text-2xl text-gray-900 mb-3 md:mb-6 tracking-widest uppercase" data-id="element-64">
          ECIG <span className="text-celeste" data-id="element-65">ARGENTINA</span>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm text-gray-600 mb-4 md:mb-8" data-id="element-66">
          <a href="#" className="hover:text-celeste transition-colors" data-id="element-67">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-celeste transition-colors" data-id="element-68">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-celeste transition-colors" data-id="element-69">
            Contacto
          </a>
        </div>

        <p className="text-gray-500 text-sm font-medium mb-4" data-id="element-70">
          &copy; {new Date().getFullYear()} ECIG ARGENTINA. Todos los derechos
          reservados.
        </p>

        <p className="text-gray-400 text-xs max-w-2xl mb-2" data-id="element-71">
          Este contenido es educativo e informativo. No reemplaza el consejo
          médico.
        </p>

        <p className="text-gray-400 text-xs max-w-2xl" data-id="element-72">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}